export const MORE_DETAILS_ATTRIBUTE_SLUGS = ["notes", "attachments"];

export const ADDRESS_GROUPS = [
  { prefix: "billing_", title: "Billing Address" },
  { prefix: "shipping_", title: "Shipping Address" },
];

export const DFT_ATTRIBUTE_SLUGS = ["discounts", "fees", "taxes"];

export const DFT_SINGULAR_LABELS = {
  discounts: "Discount",
  fees: "Fee",
  taxes: "Tax",
};

export const DFT_TYPE_TO_SLUG = {
  Discount: "discounts",
  Fee: "fees",
  Tax: "taxes",
};

export const DEFAULT_INVOICE_STATUS = "Draft";

export const INVOICE_STATUS_ACTIONS = {
  Draft: ["Send", "Void"],
  Created: ["Send", "Void"],
  Sent: ["MarkPaid", "Void", "MarkUncollectible"],
  Delayed: ["MarkPaid", "Void", "MarkUncollectible"],
  Paid: [],
  Void: [],
  Uncollectible: [],
};

export const INVOICE_TERMINAL_STATUSES = new Set([
  "Paid",
  "Void",
  "Uncollectible",
]);

export const INVOICE_EDITABLE_STATUSES = new Set(["Draft", "Created"]);

export const STATUS_TRANSITION_LABELS = {
  Paid: {
    past: "marked Paid",
    menu: "Mark Paid",
    bulk: "Mark Paid",
  },
  Void: {
    past: "Voided",
    menu: "Void Invoice",
    bulk: "Void",
  },
  Uncollectible: {
    past: "marked Uncollectible",
    menu: "Mark Uncollectible",
    bulk: "Mark Uncollectible",
  },
};

export const SUB_RESOURCE_ATTRIBUTE_SLUGS = [
  "discounts",
  "fees",
  "taxes",
  "payment_terms",
];

export const RECALC_REFETCH_DELAY_MS = 500;
export const PDF_DOWNLOAD_FEEDBACK_MS = 400;
export const PDF_PRINT_FEEDBACK_MS = 1500;
export const PDF_BLOB_REVOKE_MS = 10000;

export const readInvoiceStatus = (entity) => {
  if (!entity) return null;
  const raw = entity.status;
  if (raw == null) return null;
  if (typeof raw === "object") return raw.value || null;
  return raw;
};

export const PAYMENT_TERM_FIELD_TOOLTIPS = {
  name: 'Shorthand label used on the invoice, e.g. "Net 30" or "2/10 Net 30".',
  discount_percent:
    "Early-payment discount percentage. If the customer pays within the discount window, they deduct this % from the invoice total.",
  discount_days:
    "Days after the invoice date during which the early-payment discount applies. After this window, the full amount is due.",
  net_days:
    "Days after the invoice date that payment is due in full. Used to auto-compute the invoice due date.",
  is_active:
    "Inactive payment terms stay on existing invoices but are hidden from the picker when creating new ones.",
};

export const DFT_TABLE_HEADERS = [
  { key: "name", title: "Name", width: 300 },
  { key: "type", title: "Type", width: 100 },
  { key: "displayValue", title: "Value", width: 140 },
];

export const LINE_ITEMS_TABLE_HEADERS = [
  { key: "name", title: "Item", width: 280 },
  { key: "quantity", title: "Quantity", width: 100 },
  { key: "unit_amount", title: "Rate", width: 140 },
  { key: "amount", title: "Amount", width: 140 },
];
